import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAdjust,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArrowUp,
  faAt,
  faBars,
  faBell,
  faBold,
  faBook,
  faBookmark,
  faBug,
  faCalendarAlt,
  faCameraRetro,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartArrowDown,
  faCertificate,
  faChartPie,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChessRook,
  faCircle,
  faCircleNotch,
  faClone,
  faCodeBranch,
  faCog,
  faCogs,
  faCoins,
  faComment,
  faComments,
  faCommentDots,
  faCopy,
  faCubes,
  faDollarSign,
  faDotCircle,
  faDownload,
  faDraftingCompass,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEraser,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFileAlt,
  faFileContract,
  faFileCsv,
  faFileInvoice,
  faFilePdf,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFlagCheckered,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFrown,
  faGlasses,
  faGripHorizontal,
  faHamburger,
  faHandPointDown,
  faHiking,
  faHome,
  faImages,
  faInfoCircle,
  faItalic,
  faKeyboard,
  faLayerGroup,
  faLightbulb,
  faList,
  faListUl,
  faListOl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMinus,
  faMoon,
  faNetworkWired,
  faPause,
  faPaperclip,
  faPaperPlane,
  faPercent,
  faPlus,
  faPlusCircle,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faReceipt,
  faReply,
  faRoad,
  faSave,
  faSearch,
  faSearchPlus,
  faSignature,
  faSitemap,
  faSmile,
  faSort,
  faSortUp,
  faSortDown,
  faSpinner,
  faSquare,
  faStar,
  faStream,
  faStroopwafel,
  faSyncAlt,
  faTable,
  faTasks,
  faThList,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTools,
  faTractor,
  faTrashAlt,
  faTrashRestore,
  faTruckPickup,
  faTv,
  faUpload,
  faUnderline,
  faUndo,
  faUser,
  faUserCheck,
  faUserCog,
  faUserPlus,
  faUserTag,
  faUsers,
  faVials,
  faUserCircle,
  faUserAstronaut,
  faPlay,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCheckSquare as farCheckSquare,
  faCircle as farCircle,
  faFile as farFile,
  faFileExcel as farFileExcel,
  faFilePdf as farFilePdf,
  faFileWord as farFileWord,
  faFrown as farFrown,
  faSmile as farSmile,
  faSquare as farSquare,
  faStar as farStar,
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faAdjust,
  faAngleDown,
  faAngleRight,
  faAngleUp,
  faArrowUp,
  faAt,
  faBars,
  faBell,
  faBold,
  faBook,
  faBookmark,
  faBug,
  faCalendarAlt,
  faCameraRetro,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartArrowDown,
  faCertificate,
  faChartPie,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faCheckSquare,
  faChessRook,
  faCircle,
  farCircle,
  faCircleNotch,
  faClone,
  faCodeBranch,
  faCog,
  faCogs,
  faCoins,
  faComment,
  faComments,
  faCommentDots,
  faCopy,
  faCubes,
  faDollarSign,
  faDotCircle,
  faDownload,
  faDraftingCompass,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEraser,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFileAlt,
  faFileContract,
  faFileCsv,
  faFileInvoice,
  faFilePdf,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFlagCheckered,
  faFolder,
  faFolderOpen,
  faFolderPlus,
  faFrown,
  faGlasses,
  faGripHorizontal,
  faHamburger,
  faHandPointDown,
  faHiking,
  faHome,
  faImages,
  faInfoCircle,
  faItalic,
  faKeyboard,
  faLayerGroup,
  faLightbulb,
  faList,
  faListUl,
  faListOl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMinus,
  faMoon,
  faNetworkWired,
  faPaperclip,
  faPaperPlane,
  faPause,
  faPercent,
  faPlay,
  faPlus,
  faPlusCircle,
  faPrint,
  faProjectDiagram,
  faQuestionCircle,
  faReceipt,
  faReply,
  faRoad,
  faSave,
  faSearch,
  faSearchPlus,
  faSignature,
  faSitemap,
  faSmile,
  faSort,
  faSortUp,
  faSortDown,
  faSpinner,
  faSquare,
  faStar,
  faStream,
  faStroopwafel,
  faSyncAlt,
  faTable,
  faTasks,
  faThList,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTools,
  faTractor,
  faTrashAlt,
  faTrashRestore,
  faTruckPickup,
  faTv,
  faUpload,
  faUnderline,
  faUndo,
  faUser,
  faUserAstronaut,
  faUserCheck,
  faUserCircle,
  faUserCog,
  faUserPlus,
  faUserTag,
  faUsers,
  faVials,
  farCheckSquare,
  farFile,
  farFileExcel,
  farFilePdf,
  farFileWord,
  farFrown,
  farSmile,
  farSquare,
  farStar

);

export function faIconImports() {}
